import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Context } from './azmanotContext';
import { LINKS, relPath } from '../../../../Routs/config';
import ModalAzmanot from './modalAzmanot/modalAzmanot';
import ModalEditAzmana from './modalAzmanot/modalEditAzmana';
import OrderListView from './Components/OrderListView';
import OrdersPageLayout from './Components/OrdersPageLayout';
import useOrderCustomer from './services/hooks/useOrderCustomer';
import { SortableField } from './types';
import './mainbar2.scss';

const OrderCustomerMain: React.FC = () => {
    const c = useOrderCustomer();

    const handleSortClick = (field: SortableField) => {
        c.setSortedValue(field);
    };
    const refetchOrders = () => {
        if (c.selectedDateStart && c.selectedDateEnd) {
            c.loadOrders(c.selectedDateStart, c.selectedDateEnd);
        }
    };

    return (
        <Context.Provider value={[c.azmanot, c.removeOrder]}>
            <Routes>
                <Route
                    index
                    element={
                        <OrdersPageLayout title={'הזמנות לקוח'} maxWidth='1000px'>
                            <OrderListView
                                azmanot={c.azmanot}
                                input={c.input}
                                user={c.user}
                                isOpenLogs={c.isOpenLogs}
                                isBlockCreateOrder={c.isBlockCreateOrder}
                                isLoading={c.isLoading}
                                statusId={c.statusId}
                                warehouseID={c.warehouseID}
                                typeFilter={c.typeFilter}
                                warehouseList={c.warehouseList}
                                groupID={c.groupID}
                                groups={c.productGroupsCatalog}
                                onOpenLogs={c.handleOpenLogs}
                                onFilterByInput={c.setInput}
                                onStatusChange={c.setStatusId}
                                onWarehouseChange={c.setWarehouseID}
                                onTypeChange={c.setTypeFilter}
                                onGroupChange={c.setGroupID}
                                onSortClick={handleSortClick}
                                onRemoveOrder={c.removeOrder}
                                onInnerTimeChange={c.setInnerTime}
                                setSelectedDateStart={c.setSelectedDateStart}
                                setSelectedDateEnd={c.setSelectedDateEnd}
                            />
                        </OrdersPageLayout>
                    }
                />
                <Route
                    path={relPath(LINKS.orders.clientOrders.create, LINKS.orders.clientOrders.mainUrl)}
                    element={
                        <ModalAzmanot
                            fileterGoods={c.productGroups}
                            setFilterGoods={c.setProductGroups}
                            fileterGoodsDefault={c.productGroupsDefault}
                            setFilterGoodsDefault={c.setProductGroupsDefault}
                            filterGoodName={c.filterGoodName}
                            setFilterGoodName={c.setFilterGoodName}
                            getAzmanot={refetchOrders}
                        />
                    }
                />
                <Route
                    path={relPath(LINKS.orders.clientOrders.editGeneral, LINKS.orders.clientOrders.mainUrl)}
                    element={<ModalEditAzmana />}
                />
            </Routes>
        </Context.Provider>
    );
};

export default OrderCustomerMain;

